import { httpAuth2 } from "@/api/auth";
import { httpPublic2 } from "@/api/public";

export const a5ScreeningRequests = {
  complete_a5_screening: function ({ context, headers, searchParams } = {}) {
    return httpPublic2
      .post("/v1/a5_screening/complete", {
        context,
        headers: { Authorization: "DOB " + headers["dob"] },
        searchParams: { genReport: searchParams.genReport, screening_id: searchParams.screeningId },
      })
      .json();
  },
  create_public_a5_screening: function ({ context, data } = {}) {
    return httpPublic2.post("/v1/a5_screening/create_public", { context, json: data }).json();
  },
  fetch_next_question: function ({ context, data, headers } = {}) {
    return httpPublic2
      .post("/v1/a5_screening/next", {
        context,
        headers: { Authorization: "DOB " + headers["dob"] },
        json: data,
      })
      .json();
  },
  fetch_previous_question: function ({ context, data, headers } = {}) {
    return httpPublic2
      .post("/v1/a5_screening/previous", {
        context,
        headers: { Authorization: "DOB " + headers["dob"] },
        json: data,
      })
      .json();
  },
  get_a5_report: function ({ context, data, headers, searchParams } = {}) {
    return httpPublic2
      .post("/v1/a5_screening/get_a5_report", {
        context,
        headers: { Authorization: "DOB " + headers["dob"] },
        json: data,
        searchParams: { screeningId: searchParams.screeningId },
      })
      .json();
  },
  get_crisis_risk: function ({ context, searchParams } = {}) {
    return httpAuth2
      .post("/v1/a5_screening/get_crisis_risk", {
        context,
        searchParams: { screening_id: searchParams.assessmentId },
      })
      .json();
  },
  get_practice_name: function ({ context, searchParams } = {}) {
    return httpPublic2
      .post("/v1/a5_screening/get_practice_name", {
        context,
        searchParams: { practiceId: searchParams.practiceId },
      })
      .json();
  },
  get_provider_names: function ({ context, headers, searchParams } = {}) {
    return httpPublic2
      .post("/v1/a5_screening/get_providers", {
        context,
        headers: { Authorization: "DOB " + headers["dob"] },
        searchParams: { screeningId: searchParams.screeningId },
      })
      .json();
  },
  notify_provider: function ({ context, data, headers, searchParams } = {}) {
    return httpPublic2
      .post("/v1/a5_screening/notify_provider", {
        context,
        headers: { Authorization: "DOB " + headers["dob"] },
        json: data,
        searchParams: { screeningId: searchParams.screeningId },
      })
      .json();
  },
};
